import { getIncludedPuzzelGroupNames } from "api/common";
import { useApiAction } from "api/drops/useApiAction";
import { userSearchTelephoneApi } from "api/puzzel/puzzel";
import { DropdownUserList } from "features/Header/PuzzelTelephone/components/CallControl/views/CallInSession/CallTransfer/DropdownUserList";
import SessionCommand from "features/Header/PuzzelTelephone/components/SessionCommand";
import {
  PuzzelUser,
  SessionCommands,
} from "features/Header/PuzzelTelephone/components/types";
import { usePuzzelExtendedStateInformation } from "features/Header/PuzzelTelephone/provider/contexts/ListenForCallStatusContext";
import { usePuzzelAuthenticationContext } from "features/Header/PuzzelTelephone/provider/contexts/PuzzelAuthenticationContext";
import { useUserValidationState } from "features/Header/PuzzelTelephone/provider/contexts/UserValidationContext";
import { validPhoneNumber } from "features/Header/PuzzelTelephone/utils";
import { useEffect, useState } from "react";
import { SearchInput } from "shared/components/Spor";
import { useOnOutsideMouseclick } from "shared/hooks/useOnOutsideMouseclick";

interface Props {
  requestId: string;
  closeSearch: () => void;
}

const TransferWithSearch = ({ requestId, closeSearch }: Props) => {
  const { iqSessionId }: any = usePuzzelExtendedStateInformation();
  const { phoneNumberPrefix } = usePuzzelAuthenticationContext();
  const { userId } = useUserValidationState();
  const [textInput, setInputText] = useState("");
  const [hasResults, setHasResults] = useState(false);
  const [userSearchState, performUserSearch] = useApiAction(
    userSearchTelephoneApi,
    false,
  );
  const operationalUserGroups = getIncludedPuzzelGroupNames();
  const userSearch = userSearchState.data?.result?.filter((user: PuzzelUser) =>
    operationalUserGroups.includes(user.userGroupName),
  );
  const { mouseclickRef } = useOnOutsideMouseclick<HTMLDivElement>(() => {
    if (!validPhoneNumber(textInput)) {
      closeSearch();
    }
  });

  const search = () => {
    performUserSearch({
      payload: {
        searchString: textInput,
        userSearchFilter: "UserLoggedOn",
      },
      param: {
        userId,
        iqSessionId,
      },
    });
  };

  const keyDownHandler = (event: any) => {
    if (event.key === "Escape") {
      closeSearch();
    } else if (event.key === "Enter") {
      search();
    }
  };

  useEffect(() => search(), [textInput]);

  useEffect(() => setHasResults(userSearch?.length > 0), [userSearch]);

  return (
    <div style={{ position: "relative" }} ref={mouseclickRef}>
      <div style={{ display: "flex", alignItems: "center", gap: "1.5rem" }}>
        <SearchInput
          width="250px"
          height="7"
          onKeyDown={keyDownHandler}
          onChange={(e) => {
            setInputText(e.target.value);
          }}
          value={textInput}
          label="Nummer eller søketekst"
        />
        {validPhoneNumber(textInput) && (
          <>
            <SessionCommand
              command={SessionCommands.TransferToPhone}
              requestId={requestId}
              destinationPhoneNumber={phoneNumberPrefix + textInput}
              disabled={!validPhoneNumber(textInput)}
            />
            <SessionCommand
              command={SessionCommands.ConsultWithPhone}
              requestId={requestId}
              destinationPhoneNumber={phoneNumberPrefix + textInput}
              disabled={!validPhoneNumber(textInput)}
            />
          </>
        )}
      </div>

      {hasResults && (
        <DropdownUserList users={userSearch} requestId={requestId} />
      )}
    </div>
  );
};

export default TransferWithSearch;
